// extracted by mini-css-extract-plugin
export default {"PortfolioSuccess":"PortfolioSuccess_PortfolioSuccess__ATXsO","SuccessAnimationImage":"PortfolioSuccess_SuccessAnimationImage__pQdva","Title":"PortfolioSuccess_Title__LzajJ"};